import { isUndefined } from 'lodash-es';

import { THRESHOLD_COLOR_DEFAULT } from '../constants.js';
import type { GaugeChartThresholdProps } from '../slots/Threshold.js';
import type { GaugeChartThresholdPropsInternal } from '../types/gauge-chart-config-internal.js';

export const applyThresholdDefaults = (
  threshold: GaugeChartThresholdProps,
): GaugeChartThresholdPropsInternal => {
  const showIndicatorDefault = isUndefined(threshold.color);

  return {
    value: threshold.value,
    showIndicator: threshold.showIndicator ?? showIndicatorDefault,
    color: threshold.color ?? THRESHOLD_COLOR_DEFAULT,
  };
};
